var _path, _polyline, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLatitude(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.627,11.4c-.904.484-1.875.94-2.898,1.354-6.37,2.578-12.354,3.265-13.4.68-.211-.521-.204-1.108-.006-1.733"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "13.289 9.482 18 11.248 16.229 15.97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m3.956,10.308c.889-4.344,4.732-7.611,9.339-7.611,5.265,0,9.532,4.268,9.532,9.532s-4.268,9.532-9.532,9.532c-3.187,0-6.008-1.564-7.739-3.965"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatitude);
export default __webpack_public_path__ + "static/media/latitude.efb7153a663e574c891e4de57b2eca47.svg";
export { ForwardRef as ReactComponent };